import React from "react";

interface UseHandleMonthChangeT {
  setCurrentDate: React.Dispatch<React.SetStateAction<Date>>;
  visibleMonths?: number;
}

function useHandleMonthChange({
  setCurrentDate,
  visibleMonths,
}: UseHandleMonthChangeT) {
  const handlePreviousMonth = () => {
    if (visibleMonths) {
      return setCurrentDate(
        (prev) =>
          new Date(prev.getFullYear(), prev.getMonth() - visibleMonths, 1)
      );
    }
    return setCurrentDate(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1)
    );
  };

  const handleNextMonth = () => {
    if (visibleMonths) {
      return setCurrentDate(
        (prev) =>
          new Date(prev.getFullYear(), prev.getMonth() + visibleMonths, 1)
      );
    }
    return setCurrentDate(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1)
    );
  };

  const handleMonthChange = (month: number) => {
    setCurrentDate((prev) => {
      return new Date(prev.getFullYear(), month, 1);
    });
  };

  return {
    handleMonthChange,
    handleNextMonth,
    handlePreviousMonth,
  };
}

export default useHandleMonthChange;
